<!-- Status / Error -->
@if (error()) {
  <div class="cl-alert cl-alert-danger" role="alert">
    <i class="fas fa-exclamation-triangle"></i> {{ error() }}
  </div>
  <p style="text-align: center; margin-top: 1rem">
    <a class="cl-a-btn cl-a-primary" (click)="retry()">Try Again</a>
    <a class="cl-a-btn" (click)="goBack()">Back</a>
  </p>
} @else if (!connected()) {
  <div style="text-align: center"><div class="cl-spinner">{{ status() }} <i class="fas fa-spinner fa-spin"></i></div></div>
}

<!-- Video -->
<div #viewerContainer class="viewer-video-wrap" tabindex="0"
     [class.hidden]="!connected()"
     (keydown)="onKeyEvent($event)"
     (keyup)="onKeyEvent($event)"
     (paste)="onPaste($event)">
  <!-- Inside the wrap, which is what goes fullscreen, so the warning shows there too. -->
  @if (pasteRejected(); as bytes) {
    <div class="cl-alert cl-alert-warning paste-rejected" role="alert">
      <i class="fas fa-exclamation-triangle" aria-hidden="true"></i>
      Not pasted: the clipboard holds {{ bytes | number }} bytes, and the host accepts up to {{ maxPasteBytes | number }}.
    </div>
  }
  <!-- ids: rtc-drm-transform keys its EME sessions by element id; one pair per screen (VTK-3622) -->
  <video #remoteVideo [id]="'crd-remote-video-' + monitor()" tabindex="0"
         playsinline
         autoplay
         (pointerdown)="onPointerDown($event)"
         (mousemove)="onMouseEvent($event)"
         (mousedown)="onMouseEvent($event)"
         (mouseup)="onMouseEvent($event)"
         (contextmenu)="$event.preventDefault()"
         (wheel)="onWheel($event)"
         (keydown)="onKeyEvent($event)"
         (keyup)="onKeyEvent($event)"
         (click)="remoteVideoRef.nativeElement.focus()"
         (resize)="layoutVideo()">
  </video>
  <audio #remoteAudio [id]="'crd-remote-audio-' + monitor()" playsinline autoplay></audio>
</div>
